var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "bundle",
      attrs: { tabindex: _vm.widgetIndex, "data-test-bundle": _vm.widgetIndex },
    },
    [
      _vm._t("default"),
      _vm._v(" "),
      _vm.widgetItem.highlighted
        ? [
            _c(
              "div",
              { staticClass: "bundle__highlight-header" },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.i18n.t("general:top_seller")) +
                    "\n      "
                ),
                _c("font-awesome-icon", { attrs: { icon: "star" } }),
              ],
              1
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "bundle__wrapper" }, [
        _c(
          "span",
          {
            staticClass: "bundle__slots",
            attrs: { "data-test-duration": _vm.duration },
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.duration) +
                " " +
                _vm._s(_vm.i18n.t("general:non_special_texts.days")) +
                "\n    "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "bundle__days",
            attrs: { "data-test-slots": _vm.units },
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.units) +
                " " +
                _vm._s(
                  _vm.i18n.t("general:non_special_texts.slot", {
                    count: _vm.units,
                  })
                ) +
                "\n    "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "bundle__price",
            attrs: { "data-test-price": _vm.state.currentLocation },
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.state.currentLocation.formattedPrice) +
                "\n    "
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "bs" },
        [
          !_vm.state.hasOtherLocations
            ? _c("dropdown-input-element", {
                staticClass: "order-widget-dropdown-input-element",
                staticStyle: { "margin-bottom": "1.25em" },
                attrs: {
                  value: _vm.state.selectedItem,
                  default: _vm.state.selectedItem,
                  items: _vm.state.dropdownItems,
                  title: _vm.i18n.t(
                    "landingpage:orderwidget.dropdown.title_other_region"
                  ),
                },
                model: {
                  value: _vm.state.selectedItem,
                  callback: function ($$v) {
                    _vm.$set(_vm.state, "selectedItem", $$v)
                  },
                  expression: "state.selectedItem",
                },
              })
            : _vm.state.selectedItem != null
            ? _c(
                "div",
                {
                  staticStyle: { padding: "0 1rem", "margin-bottom": "1.25em" },
                },
                [
                  _c("strong", [
                    _vm._v(
                      _vm._s(
                        _vm.i18n.t(
                          "landingpage:orderwidget.dropdown.title_other_region"
                        )
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "location-dropdown__value location-dropdown__value--cursor-default",
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.state.selectedItem.title) +
                          "\n      "
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "button bundle__button",
          attrs: {
            href: "#",
            disabled: _vm.state.currentLocation === null,
            "data-test-button-order": "",
          },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.onWidgetSubmit.apply(null, arguments)
            },
          },
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(_vm.i18n.t("general:non_special_texts.order")) +
              "\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "form",
        {
          ref: "orderWidgetForm",
          attrs: { method: "post", action: _vm.state.currentLocation.orderUrl },
        },
        [
          _c("input", {
            attrs: { type: "hidden", name: "data[Order][units]" },
            domProps: { value: _vm.units },
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { type: "hidden", name: "data[Order][duration]" },
            domProps: { value: _vm.duration },
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { type: "hidden", name: "data[Order][location]" },
            domProps: { value: _vm.state.currentLocation.key },
          }),
        ]
      ),
      _vm._v(" "),
      _vm.state.showRegionModal
        ? [
            _c(
              "div",
              { staticClass: "bs" },
              [
                _c("region-switcher-modal", {
                  on: {
                    "on-cancel-click": function ($event) {
                      _vm.state.showRegionModal = false
                    },
                    "on-accept-click": _vm.onRegionSwitcherConfirm,
                  },
                }),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }